var map = {
	"./icon-arrow-right.svg": [
		231
	],
	"./icon-close.svg": [
		228
	],
	"./icon-create-order.svg": [
		882,
		2
	],
	"./icon-dashboard.svg": [
		883,
		3
	],
	"./icon-invoice.svg": [
		884,
		4
	],
	"./icon-list.svg": [
		885,
		5
	],
	"./icon-menu.svg": [
		227
	],
	"./icon-order.svg": [
		886,
		6
	],
	"./icon-orders.svg": [
		887,
		7
	],
	"./icon-report.svg": [
		888,
		8
	],
	"./icon-score.svg": [
		889,
		9
	],
	"./icon-trash.svg": [
		230
	],
	"./icon-user.svg": [
		890,
		10
	],
	"./order-placed.svg": [
		229
	],
	"./svg.svg": [
		891,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 814;
module.exports = webpackAsyncContext;